var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.76 230.705L219.01 205.775V103.005L176.76 127.925V230.695V230.705Z",
    fill: "#29A063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.76 230.705L32.1301 147.195V44.4346L176.76 127.925V230.695V230.705Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3801 19.4946L32.1301 44.4246L176.76 127.915L219.01 102.995L74.3801 19.4946Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.35 109.104L83.25 135.334L96.09 142.865L95.34 167.485L112.22 142.385C107.78 139.695 103.31 137.044 98.87 134.344C99.02 125.904 99.19 117.504 99.35 109.104Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9501 30.8047L51.3801 46.0247L55.52 48.4047L80.8 33.0247",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.6 62.9045L107.03 78.1145L111.17 80.5046L136.45 65.1245",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1201 37.1646L62.55 52.3846L66.6901 54.7646L91.9701 39.3846",
    fill: "#B2E8C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.22 43.6348L73.6499 58.8447L77.7899 61.2347L103.07 45.8547",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.35 50.0645L84.78 65.2745L88.92 67.6644L114.2 52.2844",
    fill: "#B2E8C5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.46 56.4846L95.8899 71.6946L100.03 74.0845L125.31 58.7046",
    fill: "#B2E8C5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M177.11 88.6045L151.54 103.815L155.68 106.205L180.96 90.8247",
    fill: "#B2E8C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.23 95.0247L162.66 110.235L166.8 112.625L192.08 97.2446",
    fill: "#B2E8C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.72 69.3345L118.15 84.5447L122.29 86.9346L147.57 71.5547",
    fill: "#B2E8C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.85 75.7546L129.28 90.9646L133.42 93.3545L158.7 77.9746",
    fill: "#B2E8C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.95 82.1746L140.38 97.3845L144.52 99.7747L169.8 84.3945",
    fill: "#B2E8C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.2 178.905L196.25 178.295L195.82 157.975L198.64 158.465L199.2 178.905Z",
    fill: "#B2E8C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.23 166.445L196.24 168.745L198.64 158.465L202.75 155.655L200.24 166.435L200.23 166.445Z",
    fill: "#72D09A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.97 155.205L195.87 157.975L198.64 158.475L202.75 155.665L199.97 155.205Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M203.19 176.605L199.2 178.905L196.25 168.795L200.24 166.495L203.19 176.605Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricC);
export default __webpack_public_path__ + "static/media/electricC.62f001b1cbafee9adb8890ee9beb8a4b.svg";
export { ForwardRef as ReactComponent };